import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { JourneyComponent } from '@app/features/journey.component';
import { ProfileComponent } from '@app/features/profile/profile.component';
import { CoverageComponent } from '@app/features/coverage/coverage.component';
import { SaveComponent } from '@app/features/save/save.component';
import { MyNeedsComponent } from '@app/features/my-needs/my-needs.component';
import {
  ProfileRouteGuard, CoverageRouteGuard,
  SaveRouteGuard, EmailRequiredGuard, ReferralCodeGuard
} from '@app/shared/common/route-guard';
import { ThankYouComponent } from './thank-you/thank-you.component';

export const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'journey', component: JourneyComponent,
    children: [
      { path: '', redirectTo: 'profile', pathMatch: 'full' },
      { path: 'profile', component: ProfileComponent, canActivate: [ReferralCodeGuard] },
      { path: 'coverage', component: CoverageComponent, canActivate: [ReferralCodeGuard, ProfileRouteGuard] },
      { path: 'my-needs', component: MyNeedsComponent, canActivate: [ReferralCodeGuard, CoverageRouteGuard] },
      { path: 'submit', component: SaveComponent, canActivate: [ReferralCodeGuard, EmailRequiredGuard] },
      { path: 'thank-you', component: ThankYouComponent, canActivate: [ReferralCodeGuard, SaveRouteGuard] }
    ]
  },
];




// WEBPACK FOOTER //
// ./src/app/features/feature.routing.ts